<template>
  <div>
    <div class="postPreview">
      <div class="post">
        <div class="d-flex align-items-center">
          <img
            src="@/assets/images/fb-avatar.jpg"
            width="32"
            height="32"
            class="mr-1"
            style="vertical-align:middle;"
          >
          <span class="userFullName">
            <template v-if="currentPage.name">
              {{ currentPage.name }}
            </template>
            <template v-else>
              {{ getPosterTrans('face_user') }}
            </template>
          </span>
        </div>
        <div
          v-if="form.files.length"
          class="previewImageType"
        >
          <b-carousel
            id="carousel-example-generic"
            no-wrap
            indicators
          >
            <b-carousel-slide
              v-for="file in form.files"
              :key="file.id"
              :img-src="file.url"
              style="height: 300px"
            />
          </b-carousel>
        </div>
        <img
          src="@/assets/images/post_button.png"
          class="img-fluid mt-1"
        >
        <div class="post">
          <p
            class="message"
          >
            <template v-if="form.caption===''">
              <span
                class="defaultMessage"
                style="width: 60%"
              />
              <span
                class="defaultMessage"
                style="width: 80%"
              />
              <span
                class="defaultMessage"
                style="width: 50%"
              />
            </template>
            <template v-else>
              <span
                style="white-space: pre;"
                v-html="form.caption"
              />
            </template>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

export default {
  name: 'PosterPreview',
  components: {
    BCarousel, BCarouselSlide,
  },
  computed: {
    ...mapGetters({
      form: 'instagram/postForm',
      images: 'poster/images',
      currentPage: 'instagram/currentAccount',
    }),
  },
  methods: {
    getPosterTrans(str) {
      return this.$t(`poster.${str}`)
    },
  },
}
</script>
